/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import { View, StyleSheet, ScrollView, TouchableOpacity } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import TitleSubSection from '@components/global/TitleSubSection';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';
import ImageContainV2 from '@components/global/ImageContainV2';
import Colors from '@global/colors';
import { convertPromotion, hasNoAccess } from '@global/helpers';
import Button from '@components/form/Button';
import * as Layout from '@components/screen/Layout';
import { isWeb, fullWidth } from '@global/screens';
import Sections from '@/screens/setting/cms/components/Sections';
import useApi from '@/hooks/useApi';
import { MsCatalog } from '@api/ms-catalog';

const TABS = [
  { label: 'Details', value: 'detail' },
  { label: 'Section', value: 'section' },
];

const CMSDetailScreen = (props) => {
  const [detailData, setDetailData] = useState({});
  // Prefer the fetched record's own page_type once loaded — route.params.type is only a
  // best-effort default for the brief window before getDetail() resolves.
  const pageType = detailData?.page_type
    ? detailData.page_type
    : props?.route?.params?.type
    ? props.route.params.type
    : 'info';

  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState('detail');
  const [sections, setSections] = useState({});

  const getCMSDetail = useApi(MsCatalog.getCMSDetail);

  const showEditButton = hasNoAccess([
    'sales_supervisor',
    'branch_head',
    'finance_supervisor',
    'regional_manager',
    'regional_support',
    'key_account_manager',
    'group_key_account_manager',
    'national_key_account_manager',
    'distributor_manager',
    'general_manager',
    'vice_president',
    'vice_president_finance',
    'budget_controller',
    'finance_head',
    'tax_support',
    'billing_supervisor',
    'regional_distributor_manager',
    'promotor',
  ]);

  const getSections = async (id) => {
    setLoading(true);
    try {
      let result = [];
      try {
        const textImages = await MsCatalog.getCMSSectionDetail(
          id,
          'text-images',
        );
        if (textImages?.data?.data?.length) {
          result = result.concat(textImages.data.data);
        }
      } catch (error) {}
      try {
        const products = await MsCatalog.getCMSSectionDetail(id, 'products');
        if (products?.data?.data?.length) {
          result = result.concat({
            type: 'products',
            products: products.data.data,
          });
        }
      } catch (error) {}
      try {
        const pdf_documents = await MsCatalog.getCMSSectionDetail(
          id,
          'pdf_documents',
        );
        if (pdf_documents?.data?.data?.length) {
          result = result.concat(pdf_documents.data.data);
        }
      } catch (error) {}
      try {
        const promotions = await MsCatalog.getCMSSectionDetail(
          id,
          'promotions',
        );
        if (promotions?.data?.data?.length) {
          result = result.concat({
            type: 'promotions',
            promotions: convertPromotion(promotions.data.data),
          });
        }
      } catch (error) {}
      setSections(result);
      setLoading(false);
    } catch (error) {
      console.log('error', error);
      setSections([]);
      setLoading(false);
    }
  };

  const getDetail = async (id) => {
    const response = await getCMSDetail.request(id);
    if (response?.data?.data && Object.keys(response.data.data).length) {
      const result = response.data.data;
      result.id = result._id;
      getSections(result._id);
      setDetailData(result);
    }
  };

  const goBack = () => {
    props.navigation.replace('CMSDetailScreen', {});
    props.navigation.navigate('CMSScreen');
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setSelectedTab('detail');
      setDetailData({});
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  return (
    <Layout.Container>
      {getCMSDetail?.loading ? (
        <Layout.Wrapper>
          <Layout.Loader />
        </Layout.Wrapper>
      ) : detailData && Object.keys(detailData).length ? (
        <>
          {isWeb ? (
            <Layout.Wrapper white={false}>
              <Layout.Back title="CMS" onCallback={() => goBack()} />
            </Layout.Wrapper>
          ) : (
            false
          )}
          <Layout.Wrapper rounded>
            <ScrollView stickyHeaderIndices={isWeb ? [] : [0]}>
              {!isWeb ? (
                <View
                  style={{
                    width: '100%',
                    flexDirection: 'row',
                    borderBottomColor: Colors.grey0,
                    borderBottomWidth: 1,
                  }}>
                  {TABS.map((item, idx) => (
                    <TouchableOpacity
                      key={idx}
                      activeOpacity={0.8}
                      style={[
                        {
                          width: fullWidth / 2,
                          paddingVertical: 12,
                          padding: 15,
                        },
                        item.value == selectedTab
                          ? {
                              borderBottomColor: Colors.blue0,
                              borderBottomWidth: 1,
                            }
                          : false,
                      ]}
                      onPress={() => setSelectedTab(item.value)}>
                      <SociollaText
                        type={item.value == selectedTab ? 'medium' : 'regular'}
                        style={[
                          item.value == selectedTab
                            ? { color: Colors.blue0 }
                            : {},
                          { textAlign: 'center' },
                        ]}>
                        {item.label}
                      </SociollaText>
                    </TouchableOpacity>
                  ))}
                </View>
              ) : (
                false
              )}
              {isWeb || selectedTab == 'detail' ? (
                <View style={styles.sectionWrapper}>
                  {isWeb ? (
                    <View
                      style={[
                        styles.rowContainer,
                        {
                          position: 'relative',
                          zIndex: 1,
                          justifyContent: 'space-between',
                        },
                      ]}>
                      <SociollaText type="medium" style={{ fontSize: 20 }}>
                        {detailData.title ? detailData.title : '-'}
                      </SociollaText>
                      <View style={{ position: 'relative' }}>
                        {showEditButton ? (
                          <Button
                            type="primary"
                            rounded
                            buttonStyle={{ width: 80, marginRight: 10 }}
                            title={
                              <SociollaText
                                type="bold"
                                style={{ color: Colors.white }}>
                                Edit
                              </SociollaText>
                            }
                            onPress={() =>
                              props.navigation.replace('CMSFormScreen', {
                                id: detailData._id,
                                title: detailData.title
                                  ? detailData.title
                                  : '-',
                                titleScreen: detailData.title
                                  ? detailData.title
                                  : '-',
                                type: pageType,
                              })
                            }
                          />
                        ) : (
                          false
                        )}
                      </View>
                    </View>
                  ) : (
                    false
                  )}
                  <View
                    style={[
                      { width: '100%' },
                      isWeb ? { paddingVertical: 15 } : { paddingBottom: 20 },
                    ]}>
                    <View
                      style={{
                        width: '100%',
                        flexDirection: isWeb ? 'row' : 'column',
                        justifyContent: 'space-between',
                      }}>
                      <View
                        style={{ width: isWeb ? 'calc(50% - 20px)' : '100%' }}>
                        <ItemDetail
                          name="Title"
                          value={detailData.title ? detailData.title : '-'}
                        />
                        <ItemDetail
                          name="Status"
                          centered
                          value={
                            <StatusBadge
                              status={
                                detailData.is_active ? 'active' : 'in_active'
                              }
                            />
                          }
                        />
                        {pageType !== 'guideline' ? (
                          <>
                            <ItemDetail
                              name="Banner Desktop"
                              centered={!detailData.banner_desktop}
                              value={
                                <ImageContainV2
                                  source={detailData.banner_desktop}
                                  style={{ width: 120 }}
                                />
                              }
                            />
                            <ItemDetail
                              name="Banner Mobile"
                              centered={!detailData.banner_mobile}
                              value={
                                <ImageContainV2
                                  source={detailData.banner_mobile}
                                  style={{ width: 120 }}
                                />
                              }
                            />
                            <ItemDetail
                              name="Enable Slider Banner"
                              centered
                              value={detailData.is_slide_banner ? 'Yes' : 'No'}
                            />
                          </>
                        ) : (
                          false
                        )}
                      </View>
                    </View>
                  </View>
                </View>
              ) : (
                false
              )}
              {isWeb || selectedTab == 'section' ? (
                <>
                  {isWeb ? (
                    <TitleSubSection
                      title={
                        pageType == 'promo' ? 'PROMOTION RULE' : 'SECTIONS'
                      }
                    />
                  ) : (
                    false
                  )}
                  <Layout.FormWrapper
                    style={{
                      paddingVertical: 10,
                      paddingHorizontal: isWeb ? 20 : 0,
                      minHeight: 200,
                      ...(!isWeb ? { paddingTop: 0 } : {}),
                    }}>
                    <Sections
                      pageType={pageType}
                      detail={detailData}
                      sections={sections}
                      loading={loading}
                      isCMSDetail
                      onReload={() => getDetail(props.route.params.id)}
                    />
                  </Layout.FormWrapper>
                </>
              ) : (
                false
              )}
            </ScrollView>
          </Layout.Wrapper>
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
});

export default CMSDetailScreen;
